/*
=========================================================
* Kinos.es React - v1.0.0
=========================================================

* Product Page: http://www.kinos.es
* Copyright 2021 Kinos & Partners S.L.

Coded by PasfID S.L.

=========================================================
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { Helmet } from "react-helmet";
// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Kcomponents footer and navbar
import DefaultNavbar from "Kcomponents/Navbars/DefaultNavbar";
import DefaultFooter from "Kcomponents/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

function Privacy() {
  const title = "Privacy Policy - Kinos.es";
  const description = `Kinos & Partner - Legal terms about the use of this website.`;

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
      </Helmet>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "internal",
          route: "/support/contact-us",
          label: "Contact",
          color: "info",
        }}
        sticky
      />
      <MKBox component="section" pt={20} pb={12}>
        <Container>
          <Grid container justifyContent="center">
            <Grid item xs={12}>
              <Card>
                <MKBox
                  variant="gradient"
                  bgColor="dark"
                  borderRadius="lg"
                  coloredShadow="dark"
                  p={3}
                  mt={-3}
                  mx={2}
                >
                  <MKTypography variant="h3" color="white">
                    Procedimiento de Gestión Interna de Canal De Denuncias de KINOS VEGA S.L.
                  </MKTypography>
                  <br />
                  <MKTypography variant="h3" color="white">
                    Índice
                  </MKTypography>
                  <MKTypography variant="body2" color="white">
                    &nbsp;1. Introducción
                    <br />
                    &nbsp;2. Definiciones
                    <br />
                    &nbsp;3. Ámbito de aplicación
                    <br />
                    &nbsp;4. Gestión del Canal Ético o de denuncias
                    <br />
                    &nbsp;5. Principios reguladores del Canal Ético
                    <br />
                    &nbsp;6. Recepción de comunicaciones
                    <br />
                    &nbsp;7. Sistema de gestión de denuncias
                    <br />
                    &nbsp;8. Proceso de tramitación de las comunicaciones recibidas
                    <br />
                    &nbsp;&nbsp;&nbsp;8.1 Recepción de la comunicación
                    <br />
                    &nbsp;&nbsp;&nbsp;8.2 Análisis preliminar de su contenido
                    <br />
                    &nbsp;&nbsp;&nbsp;8.3 Admisión a trámite
                    <br />
                    &nbsp;&nbsp;&nbsp;8.4 Registro
                    <br />
                    &nbsp;&nbsp;&nbsp;8.5 Acuse de recibo
                    <br />
                    &nbsp;&nbsp;&nbsp;8.6 Traslado o delegación
                    <br />
                    &nbsp;&nbsp;&nbsp;8.7 Instrucción o comprobación de los hechos
                    <br />
                    &nbsp;&nbsp;&nbsp;8.8 Resolución y propuesta de actuación
                    <br />
                    &nbsp;&nbsp;&nbsp;8.9 Comunicación de la resolución a los afectados
                    <br />
                    &nbsp;&nbsp;&nbsp;8.10 Cierre del expediente y elaboración de informes de
                    reporte
                    <br />
                    &nbsp;9. Protección de datos de carácter personal
                    <br />
                    &nbsp;10. Compromisos de la Función de Cumplimiento
                    <br />
                    &nbsp;11. Relación con otros procedimientos vigentes
                    <br />
                    &nbsp;12. Declaración de cumplimiento
                    <br />
                    &nbsp;13. Aprobación, entrada en vigor y actualización
                  </MKTypography>
                  <br />
                  <MKTypography variant="h3" color="white">
                    1. INTRODUCCIÓN
                  </MKTypography>
                  <MKTypography variant="body2" color="white">
                    KINOS VEGA S.L. tiene implantado un Código Ético o de denuncias en el que
                    establece los principios éticos y de actuación con los que se compromete en su
                    actividad empresarial y define el marco de comportamiento a seguir por los
                    Miembros de la Organización en el desarrollo de su desempeño profesional. En la
                    voluntad de dar una adecuada respuesta ante cualquier duda, discrepancia o
                    irregularidad en el cumplimiento de dicho Código, así como para colaborar en la
                    vigilancia del cumplimiento del conjunto de las normas aplicables a muestra
                    entidad y a sus Miembros, se activa este Canal Ético o de denuncias como cauce
                    de comunicación y conocimiento, a través del procedimiento que se regula en este
                    documento.
                    <br />
                    <br />
                    El Canal Ético es, por tanto, un medio de comunicación confidencial y
                    transparente para que, tanto los Miembros de nuestra entidad, como otras partes
                    interesadas de la misma, cuenten con un cauce adecuado para informar de aquellos
                    comportamientos que puedan conllevar alguna irregularidad o de algún acto
                    contrario a la legalidad o a las normas de comportamiento del Código Ético y
                    demás normas internas aplicables, sean cometidos por otros Miembros de la
                    Organización o por representantes o empleados de empresas que colaboran con
                    nuestra entidad en sus distintas actividades.
                    <br />
                    <br />
                    Su finalidad es establecer los mecanismos necesarios para comunicar y gestionar
                    de manera temprana cualquier cuestión relacionada con el alcance, cumplimiento o
                    interpretación de la normativa aplicable a la Organización, así como,
                    especialmente, aquellos comportamientos de los que pudiera derivarse un delito
                    que pueda conllevar responsabilidad penal para la persona jurídica.
                    <br />
                    <br />
                    El presente documento tiene como objetivo desarrollar el procedimiento de este
                    canal de comunicación.
                  </MKTypography>
                  <br />
                  <MKTypography variant="h3" color="white">
                    2. DEFINICIONES
                  </MKTypography>
                  <MKTypography variant="body2" color="white">
                    Se relacionan a continuación las definiciones de aquellos términos que se
                    utilizan de manera frecuente en el presente documento:
                    <br />
                    <br />
                    <b>Comunicación:</b> declaración por la que cualquier Miembro de la
                    Organización, Socio de Negocio o Tercero deja constancia de una cuestión acerca
                    del alcance, interpretación o cumplimiento de la normativa aplicable a la
                    Organización. En función de su contenido, una comunicación puede contener una
                    consulta o una denuncia.
                    <br />
                    <b>Consulta:</b> comunicación por la que cualquier Miembro de la Organización,
                    Socio de Negocio o Tercero solicita una aclaración, respuesta o criterio sobre
                    el alcance, interpretación o cumplimiento de la normativa aplicable a la
                    Organización.
                    <br />
                    <b>Denuncia:</b> comunicación relativa a un posible incumplimiento de la
                    normativa aplicable al Responsable del Sistema interno de información.
                    <br />
                    <b>Denunciado:</b> persona física o jurídica a la que se le imputa un presunto
                    incumplimiento objeto de investigación por parte del responsable del sistema
                    interno de información
                    <br />
                    <b>Informante:</b> persona física o jurídica con acceso al Canal Ético que
                    realiza una denuncia.
                    <br />
                    <b>Incumplimiento:</b> comportamiento, activo u omisivo que suponga la
                    infracción de la normativa aplicable al KINOS VEGA S.L. Un incumplimiento puede
                    ser más o menos grave, abarcando desde el mero incumplimiento formal de un
                    requisito incluido en una norma interna hasta la comisión de hechos
                    constitutivos de un delito potencialmente imputable a la Organización.
                    <br />
                    <b>Miembros de la Organización:</b> los integrantes del örgano de
                    Administración, directivos, empleados, trabajadores o empleados temporales o
                    bajo convenio de colaboración, y voluntarios de la Organización y el resto de
                    personas bajo subordinación jerárquica de cualquiera de los anteriores.
                    <br />
                    <b>Responsable del Sistema Interno de información:</b> Órgano unipersonal o
                    colegiado, dotado de poderes autónomos de iniciativa y control, al que se le
                    confía, entre otros cometidos, la responsabilidad de supervisar el adecuado
                    funcionamiento del Sistema de Gestión de Cumplimiento de la Organización en
                    general.
                    <br />
                    <b>Socios de Negocio:</b> cualquier persona jurídica o física, salvo los
                    Miembros de la Organización, con quien la Organización mantiene o prevé
                    establecer algún tipo de relación de negocio. A modo enunciativo, pero no
                    limitativo, se incluyen intermediarios como agentes o comisionistas, asesores
                    externos, proveedores, clientes.
                    <br />
                    <b>Sujetos afectados por este documento:</b> todos los Miembros de la
                    Organización así como los Socios de Negocio o Terceros que tengan relación de
                    negocio con KINOS VEGA S.L.
                    <br />
                    <b>Tercero:</b> persona física o jurídica u organismo independiente de la
                    Organización.
                  </MKTypography>
                  <br />
                  <MKTypography variant="h3" color="white">
                    3. ÁMBITO DE APLICACIÓN
                  </MKTypography>
                  <MKTypography variant="body2" color="white">
                    El presente canal de denuncias se establece para que los diferentes grupos de
                    interés como son la Alta Dirección, Empleados, socios, accionistas, personas que
                    pertenezcan al órgano de administración de la organización, proveedores,
                    representantes de la sociedad en general, cualquier persona que trabaje para o
                    bajo la supervisión y la dirección de contratistas, subcontratistas y
                    proveedores, etc, con los que la Organización se relaciona en un contexto
                    laboral o profesional, puedan comunicar sus dudas, sugerencias, posibles
                    conductas irregulares o cualquier incumplimiento de las normas recogidas en el
                    Código de Conducta, Política Anticorrupción u otra normativa interna o externa.
                    <br />
                    <br />
                    Es un canal confidencial e incluso anónimo a través del cual se podrá comunicar
                    cualquier conducta irregular que esté teniendo lugar en el seno de la
                    Organización:
                    <br />
                    <br />
                    El Canal Ético o de denuncias debe ser fácilmente lugar visible en la página web
                    de nuestra entidad y fácilmente accesible a los miembros de nuestra entidad y/o
                    en su defecto en lugar visible del centro físico donde opere la empresa.
                  </MKTypography>
                  <br />
                  <MKTypography variant="h3" color="white">
                    4. GESTIÓN DEL CANAL ÉTICO O DE DENUNCIAS
                  </MKTypography>
                  <MKTypography variant="body2" color="white">
                    El canal ético o de denuncias se trata de un canal alojado en una plataforma web
                    externa que cumple con los más altos estándares de confidencialidad y seguridad
                    de la información, además permite el anonimato de las denuncias y/o consultas.
                    <br />
                    <br />
                    La gestión del Canal Ético o de denuncias corresponde a una empresa externa con
                    el cual se ha formalizado el pertinente contrato de prestación de servicios y
                    que cumple con los cánones de confidencialidad y seguridad en la información
                    recibida a través del canal de denuncias. Dicha entidad debe asumir las labores
                    que a continuación se detallan:
                    <br />
                    a. Recepción, verificación y tratamiento de las comunicaciones recibidas.
                    <br />
                    b. Gestión y mantenimiento del archivo de los casos recibidos y de los
                    expedientes generados.
                    <br />
                    c. Revisión y control del funcionamiento del Canal Ético o de denuncias. d.
                    Actualización periódica del Procedimiento.
                    <br />
                    e. Llevanza del libro-registro de las informaciones recibidas y de las
                    investigaciones internas a que hayan dado lugar.
                  </MKTypography>
                  <br />
                  <MKTypography variant="h3" color="white">
                    5. PRINCIPIOS REGULADORES DEL CANAL ÉTICO
                  </MKTypography>
                  <MKTypography variant="body2" color="white">
                    I. Obligación de comunicar: Los Miembros de nuestra entidad, así como otras
                    partes interesadas en ésta, que tuvieran indicios racionales y razonables de la
                    comisión de una irregularidad o de algún acto contrario a la legalidad, o a las
                    normas internas aplicables que la Organización adopte voluntariamente, deberán
                    comunicarlo al Responsable del Sistema interno de información. En el caso de las
                    personas que mantienen relación laboral con la Organización, relación mercantil
                    o desarrollo de un servicio, esta obligación se considera parte imprescindible
                    de la buena fe en el cumplimiento contractual. Por ello, todos los empleados
                    tienen la obligación de poner en conocimiento del Responsable del Sistema
                    interno de información cualquier dato o indicio de que pueda haberse cometido o
                    pueda cometerse un incumplimiento de la normativa aplicables.
                    <br />
                    <br />
                    II. Garantía de confidencialidad: La identidad de la persona que notifique un
                    incumplimiento a través del Canal Ético será tratada como información
                    confidencial, pudiendo incluso ser anónima. Por ello, no será desvelada a los
                    que pudieran verse inmersos en un proceso de verificación. Los datos de las
                    personas que realicen la comunicación sólo podrán ser desvelados a las
                    autoridades administrativas o judiciales, en la medida en que éstos lo
                    requirieran como consecuencia del procedimiento derivado del objeto de la
                    comunicación, como a las personas implicadas en cualquier investigación
                    posterior o procedimiento judicial iniciado por y como consecuencia de la misma.
                    La cesión de los datos se hará en conformidad con lo preceptuado en la
                    legislación sobre protección de datos de carácter personal.
                    <br />
                    <br />
                    III. Promoción del Canal Ético: Nuestra entidad promoverá la difusión de la
                    existencia de este canal de denuncias en beneficio de un mejor funcionamiento de
                    sus servicios, por lo que agradece y promueve su utilización.
                    <br />
                    <br />
                    IV. Protección del informante: La denuncia, ya sea realizada por personas ajenas
                    o vinculadas a la Organización, es una conducta que la Organización promueve y
                    agradece, en beneficio del mejor desempeño de su actividad empresarial, por lo
                    que no podrá dar lugar a ninguna consecuencia negativa para el informante. V.
                    Denuncias falsas: Se entenderá como denuncia falsa:
                    <br />
                    <br />
                    (1) aquella que no esté basada en hechos o indicios de los que razonablemente
                    pueda desprenderse un hecho anómalo o comportamiento irregular;
                    <br />
                    <br />
                    (2) la formulada aun cuando el autor sea consciente de la falsedad de los hechos
                    y/o los tergiverse voluntariamente. En el caso de que, como resultado de la
                    investigación se compruebe que una denuncia ha sido interpuesta de mala fe en
                    base a datos falsos o tergiversados, se comprobará si existe relación laboral
                    con el informante para, en su caso, comunicárselo al Director o responsable de
                    Recursos Humanos para que adopte las medidas disciplinarias que estime
                    convenientes.
                  </MKTypography>
                  <br />
                  <MKTypography variant="h3" color="white">
                    6. RECEPCIÓN DE COMUNICACIONES
                  </MKTypography>
                  <MKTypography variant="body2" color="white">
                    Las comunicaciones al Canal Ético o denuncias pueden remitirse por diversos
                    canales:
                    <br />
                    <br />
                    a. Correo electrónico: info@kinos.es
                    <br />
                    b. Web: www.kinos.es
                    <br />
                    c. Vía telefónica: +34 952260231
                    <br />
                    d. Dirección Postal: Avenida Simón Bolivar nº 17 local 24 CP 29011 Málaga A la
                    atención de Joaquín Morales Mérida
                  </MKTypography>
                  <br />
                  <MKTypography variant="h3" color="white">
                    7. SISTEMA DE GESTIÓN DE DENUNCIAS
                  </MKTypography>
                  <MKTypography variant="body2" color="white">
                    Comprende las herramientas informáticas habilitadas por KINOS VEGA S .L. para
                    registrar y archivar las comunicaciones recibidas y la documentación generada en
                    su proceso de tramitación.
                    <br />
                    <br />
                    El Sistema de Gestión de Denuncias de KINOS VEGA S.L. cuenta con las medidas de
                    seguridad técnicas y organizativas necesarias para garantizar el máximo nivel de
                    confidencialidad posible. La información que contenga datos de carácter personal
                    sensible será tratada con las medidas de seguridad apropiadas de acuerdo con lo
                    dispuesto en la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos
                    Personales y Garantía de Derechos Digitales y en el Reglamento UE 2016/679 del
                    Parlamento Europeo y del Consejo de 27 de abril de 2016 relativo a la protección
                    de las personas físicas (en adelante, RGPD).
                    <br />
                    <br />
                    El Responsable del Sistema Interno de Información mantendrá actualizado un
                    listado de personas con capacidad de acceder a la información contenida en el
                    buzón de Denuncias, con expresión de las acciones que pueden realizar, si lo
                    estimara conveniente. El acceso a los datos contenidos en documentos de
                    tramitación del canal de denuncias quedará limitado exclusivamente al personal
                    que lleve a cabo las funciones de cumplimiento, auditoría interna de la
                    Organización y, en su momento, la auditoría externa.
                  </MKTypography>
                  <br />
                  <MKTypography variant="h3" color="white">
                    8. PROCESO DE TRAMITACIÓN DE LAS COMUNICACIONES RECIBIDAS
                  </MKTypography>
                  <MKTypography variant="body2" color="white">
                    La tramitación de las comunicaciones recibidas debe realizarse respetando las
                    siguientes fases:
                    <br />
                    <br />
                    1. Recepción de la comunicación.
                    <br />
                    2. Análisis preliminar de su contenido.
                    <br />
                    3. Admisión a trámite.
                    <br />
                    4. Registro.
                    <br />
                    5. Acuse de recibo.
                    <br />
                    6. Traslado o delegación.
                    <br />
                    7. Instrucción o comprobación de los hechos
                    <br />
                    8. Resolución y propuesta de actuación.
                    <br />
                    9. Comunicación de la Resolución a los afectados.
                    <br />
                    10. Cierre del Expendiente y elaboración de informes de reporte a los órganos de
                    gobierno.
                  </MKTypography>
                  <br />
                  <MKTypography variant="h4" color="white">
                    8.1 Recepción de la comunicación
                  </MKTypography>
                  <MKTypography variant="body2" color="white">
                    Las comunicaciones del Canal Ético pueden recibirse a través de los distintos
                    medios de acceso al Canal reflejados en el apartado 5 del presente
                    procedimiento.
                    <br />
                    <br />
                    Una vez recibida la comunicación, el Responsable de la gestión interna del canal
                    de denuncias dará traslado al Responsable del Sistema Interno de Información que
                    actuará en función de su contenido de la siguiente forma:
                    <br />
                    <br />
                    - Si el contenido de la comunicación es una consulta, el Responsable del Sistema
                    Interno de Información responderá a la mayor brevedad posible a las cuestiones
                    planteadas, por la misma vía por la que le fue comunicada la consulta;
                    <br />
                    <br />- Si el contenido de la comunicación es una consulta, el Responsable del
                    Sistema Interno de Información responderá a la mayor brevedad posible a las
                    cuestiones planteadas, por la misma vía por la que le fue comunicada la
                    consulta;
                  </MKTypography>
                  <br />
                  <MKTypography variant="h4" color="white">
                    8.2 Análisis preliminar de su contenido
                  </MKTypography>
                  <MKTypography variant="body2" color="white">
                    Toda comunicación que se refiera a un posible incumplimiento (esto es, una
                    denuncia) debe ser objeto de un análisis preliminar por parte del Responsable
                    del Sistema Interno de Información para decidir sobre su posible admisión y
                    registro o rechazo.
                    <br />
                    <br />
                    El Responsable del Sistema Interno de Información documentará los motivos para
                    admitir a trámite y registrar o para rechazar una comunicación relativa a un
                    posible incumplimiento, a través de una ficha, que podrá contener, según los
                    casos, la siguiente información:
                    <br />
                    <br />
                    <ul>
                      <li>
                        Denominación descriptiva de la denuncia, con expresión de su número de
                        referencia única y su fecha de recepción.
                      </li>
                      <li>
                        Resumen de datos aportados en la denuncia, con la discriminación de los
                        datos objetivos y los datos subjetivos.
                      </li>
                      <li>
                        Análisis de la información y la documentación remitida con la denuncia.
                      </li>
                      <li>
                        Valoración del contenido de la denuncia y de la fiabilidad del informante.
                        El anonimato del informante se tratará, en principio, como un indicio de
                        menor credibilidad de los hechos denunciados.
                      </li>
                      <li>
                        Decisión sobre la admisión a trámite de la denuncia, con expresión, si se
                        considera oportuno, de las actuaciones a seguir.
                      </li>
                      <li>
                        Medidas excepcionales adoptadas, en el supuesto en el que el Responsable del
                        Sistema Interno de Información las haya considerado necesarias o
                        convenientes por motivos de urgencia.
                      </li>
                      <li>
                        Designación del instructor responsable, si se valorase conveniente delegar
                        esta función, por parte del Responsable del Sistema Interno de Información.
                      </li>
                    </ul>
                    <br />
                    En este análisis preliminar se valorará la conveniencia de remitir a otras
                    instancias de la entidad informaciones que no sean objeto de este Canal o que
                    tengan un procedimiento distinto y específico, si procediera.
                    <br />
                    <br />
                    Si se trata de una comunicación que afecte a una actuación de Socios de nuestra
                    entidad, se procederá a su comprobación en colaboración con el área que mantenga
                    la interlocución con dicho Socio y, en su caso, se remitirá al responsable del
                    Sistema Interno de Información que desempeñe análogas tareas en esa entidad.
                    <br />
                    <br />
                    En el caso de las comunicaciones en que se ponga de manifiesto un mal
                    funcionamiento de algún Departamento o Área de la Organización o un
                    incumplimiento de los compromisos con los clientes, se utilizarán los canales
                    establecidos para tratar este tipo de quejas o reclamaciones, informando de su
                    traslado al informante.
                    <br />
                    <br />
                    También se decidirá si procede acumular la instrucción a otros procedimientos
                    análogos ya en curso.
                  </MKTypography>
                  <br />
                  <MKTypography variant="h4" color="white">
                    8.3 Admisión a trámite
                  </MKTypography>
                  <MKTypography variant="body2" color="white">
                    Las denuncias habrán de contener para su admisión a trámite:
                    <br />
                    <br />
                    - Los hechos o comportamientos a que afecta, y su repercusión sobre la
                    Organización, el informante, compañeros, Socios de Negocio, o Terceros. - Los
                    elementos de acreditación o prueba de que se dispone (documentos, testigos,
                    etc.). La falta de identificación del informante no será hecho suficiente para
                    descartar la tramitación de una denuncia.
                    <br />
                    <br />
                    En el caso de que la comunicación fuese anónima, el responsable del sistema
                    interno de información en razón a la diligencia debida valorará acometer una
                    comprobación de los hechos o su rechazo sin más trámites. Para ello deberá
                    evaluar la apariencia de veracidad de la denuncia y a los datos o indicios que
                    aporte. En todo caso deberá dejar documentada por escrito su decisión.
                    <br />
                    <br />
                    No se tramitará ninguna denuncia en la que, de forma notoria, la actuación
                    objeto de la misma no constituya una conducta que pueda implicar la comisión de
                    alguna irregularidad o de algún acto contrario a la legalidad o las normas de
                    comportamiento incluidas en el Código Ético.
                  </MKTypography>
                  <br />
                  <MKTypography variant="h4" color="white">
                    8.4 Registro
                  </MKTypography>
                  <MKTypography variant="body2" color="white">
                    Las denuncias admitidas a trámite se registrarán en un libro registro con un
                    número de referencia único a efectos de que sea fácilmente localizable,
                    cumplimentando un formato normalizado de registro.
                  </MKTypography>
                  <br />
                  <MKTypography variant="h4" color="white">
                    8.5 Acuse de recibo
                  </MKTypography>
                  <MKTypography variant="body2" color="white">
                    Una vez realizado el análisis preliminar de la denuncia, si en la misma
                    estuviese correctamente identificado el informante, el responsable del sistema
                    interno de información procederá a su acuse de recibo, con información en
                    cualquiera de estos sentidos: Con independencia de la categorización de la
                    comunicación, por parte del Responsable del Sistema Interno de Información, se
                    remitirá al informante acuse de recibo de su comunicación en un plazo máximo de
                    7 días naturales desde la recepción.
                    <br />
                    <br />
                    Si la denuncia es considerada no pertinente, improcedente o no relacionada con
                    los fines del presente Procedimiento, se enviará al informante una notificación
                    informativa de ello.
                    <br />
                    <br />
                    Igualmente debe informarse al informante del traslado a otros canales
                    habilitados para la tramitación de quejas o reclamaciones comerciales o de otra
                    índole
                    <br />
                    <br />
                    Si el informante decidiera realizar una denuncia anónima sin proporcionar ningún
                    correo electrónico de contacto, al concluir el proceso de comunicación recibirá
                    una información en una ventana emergente con el acuse de recibo de esa denuncia
                    en el que se le asignará un número de referencia para que pueda obtener
                    información sobre la misma en futuras comunicaciones.
                    <br />
                    <br />
                    Le advertimos que si el informante no proporcionara un correo electrónico de
                    contacto, el cual no deberá ser necesariamente identificativo del mismo, no
                    podrá recibir comunicaciones de nuestra entidad sobre estado de tramitación y
                    demás comunicaciones, si bien no se preocupe pues le responderemos dentro del
                    plazo legalmente establecido, y podrá tener acceso a los seguimientos que se
                    realicen sobre su denuncia accediendo a través del enlace de acceso a
                    www.kinos.es con el mismo usuario y contraseña con el que interpuso su denuncia
                    e incluyendo el nº de identificador de la misma.
                    <br />
                    <br />
                    Cuando la denuncia sea considerada como pertinente, pero su contenido sea
                    insuficiente, incompleto, o no proporcione el detalle necesario para que se
                    pueda iniciar la instrucción del expediente, entonces se remitirá una
                    notificación informando al informante de la aceptación de la comunicación y
                    solicitando la información adicional necesaria.
                    <br />
                    <br />
                    Cuando la denuncia sea pertinente, y la información o documentación facilitada
                    sea suficiente para el inicio de la correspondiente instrucción del expediente,
                    entonces se remitirá una notificación informando al informante sobre el inicio
                    de la gestión de la correspondiente instrucción.
                    <br />
                    <br />
                    KINOS VEGA S.L. debe garantizar en todo momento la confidencialidad del
                    informante y la ausencia de represalias ante denuncias realizadas de buena fe.
                    Por ello, se excluirá de la información que se facilite al denunciado en el
                    ejercicio de su derecho de acceso la identidad del informante o aquellas
                    circunstancias que lo hagan identificable frente al denunciado.
                    <br />
                    <br />
                    El plazo para acusar recibo de las denuncias a los informantes no debe
                    sobrepasar los siete días naturales.
                    <br />
                    <br />
                    No obstante, cuando exista un riesgo importante de que dicha comunicación
                    pusiera en peligro la investigación eficaz de los hechos objeto de la denuncia o
                    la recopilación y análisis de las pruebas necesarias, el responsable del sistema
                    interno de información podrá incluir en el expediente una justificación por
                    escrito parta obviar esta comunicación.
                  </MKTypography>
                  <br />
                  <MKTypography variant="h4" color="white">
                    8.6 Traslado o delegación
                  </MKTypography>
                  <MKTypography variant="body2" color="white">
                    El responsable del sistema interno de información podrá delegar toda o parte de
                    las fases de la instrucción o solicitar el apoyo de especialistas de las Áreas o
                    empresas filiales para que le ayuden con la instrucción de las denuncias, si las
                    hubiera.
                    <br />
                    <br />
                    Estos instructores deberán guardar confidencialidad y secreto profesional en su
                    intervención y respetar en todo caso los principios de este procedimiento.
                    <br />
                    <br />
                    Si una denuncia recibida en el Canal Ético incide en el ámbito de competencia de
                    la Asesoría confidencial en materia de acoso sexual, el responsable del sistema
                    interno de información dará oportuno traslado de la misma a la citada Asesoría
                    Confidencial para su tramitación. La Asesoría confidencial informará al
                    Responsable del Sistema Interno de Información del cierre de sus procedimientos
                    para éste que los pueda incluir en sus reportes a los órganos de gobierno.
                    <br />
                    <br />
                    Si en cualquier momento de la tramitación se tuviese conocimiento de la
                    existencia de actuaciones en el ámbito judicial o administrativo por los mismos
                    hechos, el responsable del sistema interno de información podrá acordar la
                    suspensión de la actuación del Canal Ético y reanudarla si hubiera aspectos
                    relevantes no decididos en aquellas.
                  </MKTypography>
                  <br />
                  <MKTypography variant="h4" color="white">
                    8.7 Instrucción o comprobación de los hechos
                  </MKTypography>
                  <MKTypography variant="body2" color="white">
                    El responsable del sistema interno de información habrá de poner de manifiesto
                    al denunciado el contenido de la denuncia que le afecte, dando la oportunidad de
                    exponer y acreditar su posición respecto de su contenido.
                    <br />
                    <br />
                    La instrucción se desarrollará por el responsable del sistema interno de
                    información o la persona o personas por él designadas para ello, en función del
                    tipo de denuncia y de las comprobaciones que resulten precisas. En el transcurso
                    de la instrucción se podrán realizar las siguientes actuaciones:
                    <br />
                    <br />
                    8.7.1. Solicitud de aclaración/información adicional: en los casos que se
                    precise, requerirá a la persona que haya realizado la comunicación para que la
                    aclare o complemente, aportando los documentos y/o datos de que pudiera disponer
                    para acreditar la existencia de la actuación o conducta irregular.
                    <br />
                    <br />
                    8.7.2. Comprobación de la veracidad y la exactitud de la comunicación en
                    relación con la conducta descrita, respetando los derechos de los afectados.
                    Todos los Miembros de la Organización están obligados a colaborar lealmente
                    durante el proceso de verificación. Las intervenciones de testigos y afectados
                    tendrán carácter estrictamente confidencial. Podrán solicitarse notas o informes
                    a Departamentos o Áreas afectadas.
                    <br />
                    <br />
                    8.7.3. Entrevista con el denunciado: respetando sus derechos, se le informará
                    del contenido de la comunicación para que exponga su versión de lo sucedido y
                    pueda aportar los medios de prueba de los que dispusiere. Así mismo se
                    mantendrán entrevistas privadas con todas las personas que pudieran verse
                    involucradas. En todo caso se levantará acta por escrito de las mismas, que
                    deberá firmarse por los intervinientes al término de las reuniones.
                    <br />
                    <br />
                    8.7.4. Atendiendo a la naturaleza de los hechos investigados, las entrevistas
                    podrán realizarse con la presencia de un testigo (superior jerárquico, compañero
                    de equipo u otra persona que se estime conveniente). En este caso, el testigo
                    también habrá de firmar las actas de las reuniones.
                    <br />
                    <br />
                    8.7.5. Informes periciales de profesionales internos o externos.
                    <br />
                    <br />
                    8.7.6. Acceso a documentos relacionados con el hecho denunciado, incluso a
                    correos corporativos del denunciado, conforme las normas establecidas para ello.
                    <br />
                    <br />
                    8.7.7. Otras actuaciones que se estimen necesarias durante la tramitación. De
                    todas las sesiones de la instrucción y las entrevistas realizadas en el
                    transcurso de la instrucción, el responsable del sistema interno de información
                    o, en su caso, el instructor, deberá dejar constancia escrita.
                    <br />
                    <br />
                    En el caso de reuniones formales, en el momento de la finalización de cada
                    reunión, se firmará una nota resumen con la conformidad, en lo posible, de todos
                    los presentes.
                  </MKTypography>
                  <br />
                  <MKTypography variant="h4" color="white">
                    8.8 Resolución y propuesta de actuación
                  </MKTypography>
                  <MKTypography variant="body2" color="white">
                    Una vez concluido el proceso de instrucción el responsable del sistema interno
                    de información redactará un informe y una conclusión o resolución. Si hubiese
                    intervenido un instructor, éste presentará un informe firmado con su propuesta
                    de resolución, que habrá de ser ratificada igualmente con la firma del
                    responsable del sistema interno de información. El escrito de resolución deberá
                    contener, como mínimo, los siguientes extremos:
                    <br />
                    <br />
                    8.8.1. Descripción del caso denunciado.
                    <br />
                    <br />
                    8.8.2. Acciones realizadas durante la instrucción del expediente, así como
                    cualquier documentación relevante analizada y que pueda suponer evidencia para
                    soportar las conclusiones. 8.8.3. Resultados obtenidos en la investigación.
                    <br />
                    <br />
                    8.8.4. Valoración o calificación de los hechos comprobados.
                    <br />
                    <br />
                    8.8.5. Propuesta, en su caso, de medidas correctivas, dirigidas a quien tenga la
                    capacidad de decisión y ejecución sobre las mismas.
                    <br />
                    <br />
                    El procedimiento deberá completarse en el plazo más breve posible, no superando
                    los tres meses a contar desde la recepción de la comunicación o, si no se
                    remitió un acuse de recibo al informante, a tres meses a partir del vencimiento
                    del plazo de 7 días después de efectuarse la comunicación, salvo casos de
                    especial complejidad que requieran una ampliación del plazo, en cuyo caso, éste
                    podrá extenderse hasta un máximo de de otros 3 meses adicionales.
                    <br />
                    <br />
                    Si la resolución concluye que un Miembro de la Organización ha cometido algún
                    incumplimiento, se procederá a aplicar medidas de corrección y, en su caso, se
                    dará traslado al Director o responsable del Área de Recursos Humanos para la
                    aplicación de las medidas disciplinarias que correspondan o, en su caso, al
                    Director del Área de Asesoría Jurídica.
                    <br />
                    <br />
                    Si la implicación es de un Socio de Negocio proveedor de mercancías, servicios
                    y/o suministros, el responsable del sistema interno de información dará traslado
                    al Departamento o Área que haya realizado la contratación o que sea responsable
                    del cumplimiento de sus compromisos.
                    <br />
                    <br />
                    Con independencia de las medidas anteriores, si las actuaciones comprobadas
                    tuvieran relación con una actuación administrativa o judicial, sea parte o no la
                    Organización, se informará de inmediato a la Asesoría Jurídica, si la hubiera y
                    a las autoridades competentes.
                    <br />
                    <br />
                    Cuando del contenido de la denuncia o de la instrucción de la misma se ponga de
                    manifiesto la posible existencia de responsabilidades penales relevantes que
                    puedan afectar a la Organización, el responsable del sistema interno de
                    información habrá de informar de inmediato al órgano de administración de la
                    entidad, siendo éste el responsable de adoptar las decisiones pertinentes
                    respecto de la denuncia, una vez haya recibido informe adecuado de su contenido.
                    <br />
                    <br />
                    En el caso de que se compruebe que una denuncia ha sido interpuesta de mala fe
                    en base a datos falsos o tergiversados por un empleado, tal extremo se pondrá de
                    manifiesto al Director o responsable de Recursos Humanos para que adopte, en su
                    caso, las medidas disciplinarias que estime convenientes.
                  </MKTypography>
                  <br />
                  <MKTypography variant="h4" color="white">
                    8.9 Comunicación de la resolución a los afectados
                  </MKTypography>
                  <MKTypography variant="body2" color="white">
                    El responsable del sistema interno de información comunicará por escrito la
                    finalización de la instrucción al informante y denunciado y su valoración,
                    indicando si se ha producido o no un incumplimiento de la normativa aplicable a
                    la Organización y, en especial, de su Código Ético.
                  </MKTypography>
                  <br />
                  <MKTypography variant="h4" color="white">
                    8.10 Cierre del expediente y elaboración de informes de reporte
                  </MKTypography>
                  <MKTypography variant="body2" color="white">
                    En todo caso, de las comunicaciones recibidas, calificación y resolución se
                    creará un libro registro sin datos personales, para acometer los estudios e
                    informes correspondientes, y promover la corrección de las situaciones en que
                    proceda.
                  </MKTypography>
                  <br />
                  <MKTypography variant="h3" color="white">
                    9. PROTECCIÓN DE DATOS DE CARÁCTER PERSONAL
                  </MKTypography>
                  <MKTypography variant="body2" color="white">
                    1. Objeto
                    <br />
                    El objetivo del presente apartado del procedimiento de Canal Ético o de
                    denuncias es informar a los comunicantes del tratamiento de los datos que se
                    llevará a cabo para la gestión y tramitación de las denuncias presentadas a
                    través del mismo. A estos efectos, los criterios de privacidad del Canal Ético
                    se encontrarán asimismo definidos en la página web corporativa.
                    <br />
                    <br />
                    Para la correcta configuración y diseño del Canal Ético, la Organización da
                    pleno cumplimiento a la normativa aplicable en materia de protección de datos;
                    de manera especial el Reglamento (UE) 2016/679 del Parlamento Europeo y del
                    Consejo, de 27 de abril de 2016, relativo a la protección de las personas
                    físicas en lo que respecta al tratamiento de datos personales y a la libre
                    circulación de estos datos y a su normativa de desarrollo.
                    <br />
                    <br />
                    Igualmente, el Canal Ético ha sido diseñado de conformidad con la Ley Orgánica
                    3/2018, de 5 de diciembre, de Protección de Datos Personales y Garantía de
                    Derechos Digitales.
                    <br />
                    <br />
                    2. Tratamiento de sus datos personales y legitimación
                    <br />
                    La finalidad del Canal Ético o de denuncias es gestionar las notificaciones
                    recibidas sobre incumplimientos de la normativa aplicable a KINOS VEGA S.L.,
                    cometidos por Miembros de la Organización o Socios de Negocio, realizar la
                    investigación de los hechos denunciados y adoptar las medidas correctivas
                    pertinentes.
                    <br />
                    <br />
                    Se trata de un cauce de comunicación confidencial entre Miembros de la
                    Organización, Socios de negocio y Terceros, vinculados a la Organización.
                    <br />
                    <br />
                    La información contenida en el Canal se eliminará a los tres meses desde la
                    resolución del expediente y se cancelará una vez transcurridos los plazos
                    legales durante los cueles pudieran derivarse procedimientos administrativos o
                    judiciales para la persona jurídica y, en todo caso, no antes de 10 años si la
                    denuncia tiene relación con el blanqueo de capitales o financiación del
                    terrorismo.
                    <br />
                    <br />
                    La legitimación viene dada por el consentimiento, el cual ha sido prestado y
                    recabado a través del Canal Ético.
                    <br />
                    <br />
                    3. Destinatarios de los datos
                    <br />
                    Únicamente tendrá acceso a la información remitida por el interesado, el
                    responsable del sistema interno de información de KINOS VEGA S.L., así como los
                    colaboradores autorizados por éste (salvo cuando se solicite una gestión sobre
                    operaciones comerciales en que hayan de intervenir los departamentos o áreas
                    afectados).
                    <br />
                    <br />
                    No se cederán los datos a Terceros, salvo obligación legal, en cuyo caso la
                    información estará a disposición de las Administraciones públicas, Jueces y
                    Tribunales, para la atención de las posibles responsabilidades.
                    <br />
                    <br />
                    4. Ejercicio de derechos
                    <br />
                    En todo momento el interesado podrá ejercitar los derechos de acceso, oposición,
                    rectificación y supresión de conformidad con lo establecido en el Reglamento
                    (UE) 2016/679 del Parlamento Europeo y del Consejo y la Ley Orgánica 3/2018, de
                    5 de diciembre.
                    <br />
                    <br />
                    En determinadas circunstancias, los interesados podrán solicitar la limitación
                    del tratamiento en sus datos, en cuyo caso únicamente los conservará el Canal
                    Ético para el ejercicio o defensa de las reclamaciones.
                    <br />
                    <br />
                    Cuando sea técnicamente posible, el interesado podrá solicitar la portabilidad
                    de sus datos a otro responsable del tratamiento.
                    <br />
                    <br />
                    Para ejercitar estos derechos, de conformidad con la legislación vigente, los
                    interesados pueden utilizar la cuenta de correo info@kinos.es adjuntando copia
                    de un documento acreditativo (DNI o Pasaporte) e indicando expresamente el
                    derecho que solicita.
                    <br />
                    <br />
                    La persona interesada podrá presentar una reclamación ante la Agencia Española
                    de Protección de Datos, especialmente cuando no esté satisfecha con el ejercicio
                    de sus derechos, para más detalle consulte la web https://www.aepd.es.
                    <br />
                    <br />
                    5. Principio de proporcionalidad y minimización de datos
                    <br />
                    - Los datos personales recabados en el marco del Canal Ético: Su uso se limitará
                    a lo estricta y objetivamente necesario para tramitar las denuncias y, si
                    procede, comprobar la realidad de los hechos denunciados;
                    <br />
                    <br />
                    - Serán tratados en todo momento de conformidad con la normativa de protección
                    de datos aplicable, para fines legítimos y específicos en relación con la
                    investigación que pueda surgir como consecuencia de la denuncia;
                    <br />
                    <br />
                    - No se utilizarán para fines incompatibles;
                    <br />
                    <br />
                    - Serán adecuados y no excesivos en relación con las citadas finalidades.
                    <br />
                    <br />
                    6. Limitación al acceso de los datos
                    <br />
                    El acceso a los datos contenidos en estos sistemas quedará limitado
                    exclusivamente a los órganos que tienen encomendada la labor de desarrollar las
                    funciones de cumplimiento, de auditoría interna de la entidad y, en su momento,
                    de auditoría externa.
                    <br />
                    <br />
                    Sólo cuando pudiera proceder la adopción de medidas disciplinarias contra un
                    Miembro de la Organización, se permitirá el tratamiento de los datos al personal
                    con funciones de gestión y control de Recursos Humanos.
                    <br />
                    <br />
                    Asimismo, y según se ha indicado, la Organización podrá servirse del apoyo de
                    terceros profesionales, ajenos a la misma, para la prestación de determinados
                    servicios relativos a la gestión del Canal Ético.
                    <br />
                    <br />
                    7. Medidas de seguridad y confidencialidad
                    <br />
                    La Organización se asegurará de que se adopten todas las medidas técnicas y
                    organizativas necesarias para preservar la seguridad de los datos registrados al
                    objeto de protegerlos de divulgaciones o accesos no autorizados.
                    <br />
                    <br />A estos efectos, la Organización ha adoptado medidas apropiadas para
                    garantizar la confidencialidad de toda la información y se asegurará de que los
                    datos relativos a la identidad del informante no sean divulgados al denunciado
                    durante la investigación, respetando en todo caso los derechos fundamentales de
                    la persona, sin perjuicio de las acciones que, en su caso, puedan adoptar las
                    autoridades judiciales competentes.
                  </MKTypography>
                  <br />
                  <MKTypography variant="h3" color="white">
                    10. COMPROMISOS DE LA FUNCIÓN DE CUMPLIMIENTO
                  </MKTypography>
                  <MKTypography variant="body2" color="white">
                    El responsable del sistema interno de información, así como, en su apoyo, las
                    personas que hayan actuado por su designación, y cualquier persona que
                    intervenga en las fases de gestión y tramitación del Canal Ético o en la
                    tramitación de comunicaciones, deberán realizar el trabajo con la máxima
                    diligencia y confidencialidad, absteniéndose de revelar informaciones, datos o
                    antecedentes a los que tengan acceso en el ejercicio de su tarea, así como de
                    utilizarlos en beneficio propio o de un Tercero.
                    <br />
                    <br />
                    El responsable del sistema interno de información y toda persona que colabore en
                    el procedimiento de gestión del Canal Ético habrán de abstenerse de actuar si,
                    por las personas a que afecta la comunicación o de la materia que se trata, se
                    deriva conflicto de interés, comunicándolo al órgano de administración de la
                    entidad y asignándose la tramitación a persona cualificada en que no concurra
                    dicha situación.
                  </MKTypography>
                  <br />
                  <MKTypography variant="h3" color="white">
                    11. RELACIÓN CON OTROS PROCEDIMIENTOS VIGENTES
                  </MKTypography>
                  <MKTypography variant="body2" color="white">
                    Este Canal Ético no debe interferir en el procedimiento de la Asesoría
                    Confidencial encargada de la tramitación de supuestos de acoso y/o violencia
                    sexual que continuará rigiéndose por su normativa específica.
                  </MKTypography>
                  <br />
                  <MKTypography variant="h3" color="white">
                    12. DECLARACIÓN DE CUMPLIMIENTO
                  </MKTypography>
                  <MKTypography variant="body2" color="white">
                    Puesto que el cumplimiento de las normas y estándares éticos compromete a toda
                    la Organización y constituye un objetivo estratégico para la misma, se espera
                    que todo el personal conozca y respete el contenido de este Procedimiento.
                    <br />
                    Kinos Vega S.L. reaccionará de forma inmediata ante eventuales incumplimientos
                    de lo establecido en este Procedimiento, conforme a lo previsto en su normativa
                    interna y dentro de los parámetros establecidos en la legislación vigente.
                  </MKTypography>
                  <br />
                  <MKTypography variant="h3" color="white">
                    13. APROBACIÓN, ENTRADA EN VIGOR Y ACTUALIZACIÓN
                  </MKTypography>
                  <MKTypography variant="body2" color="white">
                    El presente procedimiento de Canal Ético ha sido aprobado por el órgano de
                    administración y dirección en su reunión de 24-11-2023.
                    <br />
                    <br />
                    A partir de ese momento se encuentra plenamente en vigor en todos sus términos.
                    <br />
                    <br />
                    Este procedimiento de Canal Ético habrá de mantenerse actualizado en el tiempo.
                    Para ello debe revisarse de forma ordinaria con periodicidad anual, y de forma
                    extraordinaria, cada vez que se produzcan variaciones en los objetivos
                    estratégicos o legislación aplicable.
                    <br />
                    <br />
                    Corresponde al Responsable del Sistema Interno de Información valorar cualquier
                    propuesta de modificación.
                  </MKTypography>
                </MKBox>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </MKBox>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Privacy;
